import React from "react";
import Header from "../Global/Header";
import WebsiteBreadCrumbs from "../Global/WebsiteBreadCrumbs";
import Womanimgfour from "./Womanimgfour";
import Exploreallthree from "../../Components/Explore/Exploreallthree";
import Footer from "../Global/Footer";
import CompanyLogo from "../Global/CompanyLogo";
import { useEffect } from "react";

function Womanimgfourmain() {
  useEffect(() => {
    document.title = "Teal Elegance Embroidered Suit | Crowd Approved Fashion";
  }, []);

  return (
    <div className="background-image body-color ">
      <Header />
      <WebsiteBreadCrumbs />
      <Womanimgfour />
      <Exploreallthree />
      <Footer />
      <CompanyLogo />
    </div>
  );
}

export default Womanimgfourmain;
